import { Typography } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";

const StoreFormInfoTextTypography = withStyles(
  {
    root: {
      color: grey[400]
    }
  },
  { name: "StoreFormInfoTextTypography" }
)(Typography);

export default StoreFormInfoTextTypography;
